// Posture's tabs as a location names them (#814). Findings was a screen of its own
// at `/findings`; it is a tab of Posture now, and its old path still lands on it,
// as the Inbox's old screens land on its filters (`inboxView.ts::legacyKindOf`).
//
// The tab is in the query, `/posture?tab=findings`, so a link can open one and a
// reload keeps it. Free of components: `routes.ts` reads it.

export const POSTURE_TABS = [
  { id: "score", label: "Score" },
  { id: "findings", label: "Findings" },
  { id: "risks", label: "Risks" },
  { id: "frameworks", label: "Frameworks" },
] as const;

export type PostureTab = (typeof POSTURE_TABS)[number]["id"];

export const POSTURE_PATH = "/posture";

/** Where the Findings screen was, before it was a tab. */
export const LEGACY_FINDINGS_PATH = "/findings";

const normalise = (pathname: string): string =>
  pathname.length > 1 && pathname.endsWith("/")
    ? pathname.slice(0, -1)
    : pathname;

/** Whether `pathname` is the old Findings screen's. */
export const isLegacyFindings = (pathname: string): boolean =>
  normalise(pathname) === LEGACY_FINDINGS_PATH;

/** The tab a location names: the old Findings path's, the query's, or Score. */
export function postureTabOf(pathname: string, search: string): PostureTab {
  if (isLegacyFindings(pathname)) return "findings";
  const named = new URLSearchParams(search).get("tab");
  return POSTURE_TABS.find((tab) => tab.id === named)?.id ?? "score";
}

/** The location of a tab: what choosing it navigates to. */
export const postureTabPath = (tab: PostureTab): string =>
  tab === "score" ? POSTURE_PATH : `${POSTURE_PATH}?tab=${tab}`;
